import React, { useEffect } from "react";
import { FullScreenLoader } from "../../../components/Loaders/FullScreenLoader";
import { useAnimatedAssetSelection } from "../../services/CaptureCollabService";
import { animated } from "react-spring";
import { StyledAssetContainer, StyleTopContainer, StyledBody, StyleBottomContainer } from "../Assets/AssetViewer";
import { StyledP, StyledB } from "../../../styles/StyledHTML";
import { SmartContainer, Stack } from "../../../styles/Containers";
import { StyledIconButton } from "../../../styles/matieralui/IconButton";
import CloseIcon from '@mui/icons-material/Close';
import { AssetCard } from "../Assets/AssetCard";
import { ImageCroppingPresets } from "../../../modules/Media/MediaUtils";
import { Divider } from "@mui/material";
import moment from "moment";
import { FullAssets } from "../Assets/redux/assets.selectors";
import { IconNext, IconPrev } from "../../Icons";
import { useKeyPress } from "../../../services/Utils";
import { AssetDownloadButton } from "../Assets/AssetDownloadButton";
import { MediaPreviewAsText } from "../../../modules/Media/MediaPreview";

export const ViewAssetViewer = ({ asset, onClose, setAssetByIndex = null }) => {
    const { animatedProps } = useAnimatedAssetSelection();

    const store = FullAssets();
    const leftArrow = useKeyPress("ArrowLeft")
    const rightArrow = useKeyPress("ArrowRight")

    const renderNavigation = () => {
        if (!store.items) return;
        if (store?.items?.count <= 1) return null;
        if (!setAssetByIndex) return null;

        return (
            <StyleBottomContainer flex align="center" justify="center">
                <StyledIconButton onClick={prev}><IconPrev /></StyledIconButton>
                <StyledIconButton onClick={next}><IconNext /></StyledIconButton>
            </StyleBottomContainer>
        )
    }

    const next = () => {
        if (!store.items) return;
        if (store?.items?.rows?.length <= 1) return;
        let nextIndex = 0;
        const current = store.items.rows.find((item, index) => {
            if (item?.id === asset?.id) {
                nextIndex = index + 1;
                return item;
            }
        })

        if (nextIndex >= store.items.rows.length) nextIndex = 0;
        setAssetByIndex(nextIndex);

    }

    const prev = () => {
        if (!store.items) return;
        if (store?.items?.rows?.length <= 1) return;
        let prevIndex = 0;
        const current = store.items.rows.find((item, index) => {
            if (item?.id === asset?.id) {
                prevIndex = index - 1;
                return item;
            }
        })

        if (prevIndex < 0) prevIndex = (store.items.rows.length - 1);

        setAssetByIndex(prevIndex);
    }

    useEffect(() => {
        if (leftArrow === true) prev();
        if (rightArrow === true) next();
    }, [leftArrow, rightArrow])

    if (!asset) return (<FullScreenLoader />)

    return (
        <animated.div style={animatedProps}>
            <StyledAssetContainer>
                <StyleTopContainer>
                    <SmartContainer data-name-editor>
                        <StyledP>{asset.name}</StyledP>

                    </SmartContainer>
                    <SmartContainer data-controls>
                        <AssetDownloadButton asset={asset} />
                        <StyledIconButton onClick={onClose}><CloseIcon /></StyledIconButton>
                    </SmartContainer>
                </StyleTopContainer>
                <StyledBody>
                    <SmartContainer data-asset>
                        <SmartContainer >
                            <AssetCard item={asset} crop={ImageCroppingPresets.preview} noControls={true} />
                        </SmartContainer>
                    </SmartContainer>
                    <Stack data-right-bar>

                        <Stack>
                            <StyledP><StyledB>&nbsp;</StyledB></StyledP>
                            <StyledP>Login or Create an Account to start collaborating</StyledP>
                        </Stack>


                        <Divider />

                        <Stack>
                            <StyledP><StyledB>Caption</StyledB></StyledP>
                            <SmartContainer>{asset.content}</SmartContainer>
                        </Stack>


                        <Divider />

                        <Stack>
                            <StyledP small><StyledB>Captured: </StyledB> {moment(asset?.capturedDate).format('YYYY-MM-DD')}</StyledP>
                            <StyledP small><StyledB>Uploaded: </StyledB> {moment(asset?.createdAt).format('YYYY-MM-DD')}</StyledP>
                            {asset?.meta?.exif?.Make && (<StyledP small><StyledB>Make: </StyledB> {asset.meta.exif.Make}</StyledP>)}
                            {asset?.meta?.exif?.Model && (<StyledP small><StyledB>Model: </StyledB> {asset.meta.exif.Model}</StyledP>)}
                            {asset?.meta?.exif?.lens && (<StyledP small><StyledB>Lens: </StyledB> {asset.meta.exif.lens}</StyledP>)}
                            {asset?.meta?.exif?.Copyright && (<StyledP small><StyledB>Copyright: </StyledB> {asset.meta.exif.Copyright}</StyledP>)}
                            {asset?.meta?.exif?.creator && (<StyledP small><StyledB>Creator: </StyledB> {asset.meta.exif.creator}</StyledP>)}
                        </Stack>

                        <Divider />

                        {asset?.meta?.attachments?.length > 0 && (
                            <Stack>
                                <StyledP small><StyledB>Additional Files: </StyledB></StyledP>
                                {asset?.meta?.attachments?.map(i => (
                                    <MediaPreviewAsText id={i?.src} />
                                ))}
                            </Stack>
                        )}





                    </Stack>


                </StyledBody>
                {renderNavigation()}

            </StyledAssetContainer >
        </animated.div >
    )
}